import {
  APP_HOST,
  VENDOR_AGS,
  VENDOR_BOOMING_GAMES,
  VENDOR_FLOWPLAY,
  VENDOR_RED_RAKE,
  VENDOR_SPIN_GAMES,
  VENDOR_WIND_CREEK
} from 'utils/constants';

const EVENT_SESSION_UPDATED = 'sessionUpdated';

const EVENT_SPIN_START = 'spinStart';
const EVENT_SPIN_END = 'spinEnd';
const SPIN_EVENTS = [EVENT_SPIN_START, EVENT_SPIN_END];

const listeners = {};

function addListener(type, callback) {
  let list = listeners[type];
  if (!list) {
    listeners[type] = list = [];
  }
  if (list.indexOf(callback) < 0) {
    list.push(callback);
  }
}

function removeListener(type, callback) {
  let list = listeners[type];
  if (list) {
    const index = list.indexOf(callback);
    if (index >= 0) {
      list.splice(index, 1);
    }
  }
}

function dispatchGameEvent(type, ...args) {
  let list = listeners[type];
  if (list) {
    for (let i = 0; i < list.length; ++i) {
      try {
        list[i](...args);
      } catch (ex) {
        console.error(ex.message || ex);
      }
    }
  }
}

export const addSpinStartListener = callback =>
  addListener(EVENT_SPIN_START, callback);
export const removeSpinStartListener = callback =>
  removeListener(EVENT_SPIN_START, callback);
export const dispatchSpinStart = data =>
  dispatchGameEvent(EVENT_SPIN_START, data);

export const addSpinEndListener = callback =>
  addListener(EVENT_SPIN_END, callback);
export const removeSpinEndListener = callback =>
  removeListener(EVENT_SPIN_END, callback);
export const dispatchSpinEnd = data => dispatchGameEvent(EVENT_SPIN_END, data);

export const addGameSessionUpdatedListener = callback =>
  addListener(EVENT_SESSION_UPDATED, callback);
export const removeGameSessionUpdatedListener = callback =>
  removeListener(EVENT_SESSION_UPDATED, callback);
export const dispatchGameSessionUpdated = gameSession =>
  dispatchGameEvent(EVENT_SESSION_UPDATED, gameSession);

const vendorData = [
  {
    id: VENDOR_AGS,
    pattern: /^https?:\/\/([^/?]+\.)?playags-games\.com(\/.*)?$/,
    syncedToSpin: true,
    delay: 4000,
    [EVENT_SPIN_START]: json => json && json.event === 'spin_start',
    [EVENT_SPIN_END]: json => json && json.event === 'spin_end'
  },
  {
    id: VENDOR_BOOMING_GAMES,
    pattern: /^https?:\/\/([^/?]+\.)?booming-games\.com(\/.*)?$/,
    syncedToSpin: false,
    delay: 4000
  },
  {
    id: VENDOR_FLOWPLAY,
    pattern: /^https?:\/\/([^/?]+\.)?7seascasino\.com(\/.*)?$/,
    syncedToSpin: false,
    delay: 0
  },
  {
    id: VENDOR_RED_RAKE,
    pattern: /^https?:\/\/([^/?]+\.)?redrakegaming\.com(\/.*)?$/,
    syncedToSpin: false,
    delay: 0,
    [EVENT_SPIN_START]: json => json && json.message === 'ROUND_START',
    [EVENT_SPIN_END]: json => json && json.message === 'ROUND_END'
  },
  {
    id: VENDOR_SPIN_GAMES,
    pattern: /^https?:\/\/([^/?]+\.)?spingames\.net(\/.*)?$/,
    syncedToSpin: undefined,
    delay: 4000,
    [EVENT_SPIN_START]: json => json && json.event === 'round_start',
    [EVENT_SPIN_END]: json => json && json.event === 'round_complete'
  },
  {
    id: VENDOR_WIND_CREEK,
    pattern: new RegExp(
      '^https:\\/\\/gameplay\\.' + APP_HOST.replace(/\./g, '\\.') + '(\\/.*)?$'
    ),
    syncedToSpin: true,
    delay: 4000,
    [EVENT_SPIN_START]: json => json && json.event === 'startRound',
    [EVENT_SPIN_END]: json => json && json.event === 'endRound'
  }
];

export function getGameVendor(origin) {
  return origin && vendorData.find(v => v.pattern.test(origin));
}

export function dispatchSpinEvent(origin, data) {
  const vendor = getGameVendor(origin);
  if (!data || !origin || !vendor) {
    return;
  }

  let json;
  if (typeof data === 'string' && data.startsWith('{') && data.endsWith('}')) {
    try {
      json = JSON.parse(data);
    } catch (ex) {
      // unexpected message format, do nothing
    }
  } else if (typeof data === 'object') {
    json = data;
  }

  const event = SPIN_EVENTS.find(e => vendor[e] && vendor[e](json));
  if (event) {
    dispatchGameEvent(event, json);
  }
}
